import React from 'react';
import { useTranslation } from 'react-i18next';

export const NewLabel = ({ text }) => {
  const { t } = useTranslation(['footer']);

  return (
    <sup className="bg-yellow rounded-full font-crystalCondensed px-2 py-1">
      {t('News')}
    </sup>
  );
};
